<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group
      [selectedIndex]="getSelectedIndex()"
      (selectedTabChange)="tabClick($event)">
      <mat-tab label="Source Countries">
        <ng-template matTabContent>
          <app-source-country></app-source-country>
        </ng-template>
      </mat-tab>
      <mat-tab label="Destination Countries">
        <ng-template matTabContent>
          <app-destination-country></app-destination-country>
        </ng-template>
      </mat-tab>
      <mat-tab label="Currency Conversion Rates">
        <ng-template matTabContent>
          <app-conversion-rate></app-conversion-rate>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *ngIf="clickedTabIndex === 0">
        <ng-template
          mat-tab-label
          *appHasAccess="'/settings/add-source-country'">
          <button
            class="btn primary-btn"
            (click)="addCountrySettings('/settings/add-source-country')">
            Add Source Country
          </button>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *ngIf="clickedTabIndex === 1">
        <ng-template
          mat-tab-label
          *appHasAccess="'/settings/add-destination-country'">
          <button
            class="btn primary-btn"
            (click)="addCountrySettings('/settings/add-destination-country')">
            Add Destination Country
          </button>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *ngIf="clickedTabIndex === 2">
        <ng-template
          mat-tab-label
          *appHasAccess="'/settings/add-conversion-rate'">
          <button
            class="btn primary-btn"
            (click)="addCountrySettings('/settings/add-conversion-rate')">
            Add Conversion Rate
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
